<template>
  <div id="Actia">
    <SovecoNavBar />
    <div class="box has-text-centered">
      <!--- 
      <span class="button is-success" @click="doGetApp()">
        Scarica l'app Android
      </span>
      -->
      <div class="box has-text-centered">
        <a href="https://sovecotech.com/apk/sovecotech33.apk"
          >Scarica l'app Android</a
        >
      </div>
    </div>
  </div>
</template>
<script>
import axios from 'axios'
import { ServiceBus } from '../ServiceBus.js'
import { UtilityMixin } from '../mixins/UtilityMixin.js'
export default {
  name: 'AndroidApp',
  mixins: [UtilityMixin],
  data() {
    return {
      apiServer: '',
      auth: null,
      prefs: null,
      actiaData: {},
      windowHeight: 0,
    }
  },
  created() {
    const vm = this
    vm.prefs = JSON.parse(vm.$localStorage.get('prefs'))
    vm.auth = JSON.parse(vm.$localStorage.get('auth'))
  },
  mounted() {
    const vm = this
    vm.api_server = vm.getApiServer()
    if (vm.auth === null || vm.auth.tipo == 3) {
      this.$router.push({
        path: 'login',
      })
    }
  },
  methods: {
    doGetApp() {
      const vm = this
      let url = 'https:www.sovecotech.com/apk/sovecotech33.apk'
      window.open(url, '_blank')
      vm.$router.push({
        path: 'map',
      })
    },
  },
}
</script>
